import { RouteConfig } from 'vue-router';

import FeeManage from '@/views/fee/Manage.vue';
import { feeBaseRoute } from './steps/base.route';
import { feeScheduleRoute } from './steps/schedule.route';

export function feeManageRoute(name: string, path: string, edit: boolean = false): RouteConfig {
  const baseName = `${name}Base`;
  const scheduleName = `${name}Schedule`;
  const children = [feeBaseRoute(baseName, edit), feeScheduleRoute(scheduleName, edit)];

  return {
    name,
    path,
    component: FeeManage,
    meta: { breadcrumb: { title: 'breadcrumbs.fee.view' } },
    children,
    props: {
      tabs: [
        { title: 'tabs.fee.base', name: baseName },
        { title: 'tabs.fee.schedule', name: scheduleName }
      ],
      edit
    },
    redirect: { name: baseName }
  };
}
